import { getViewer } from 'store/viewerStore';
import { postProcess, renderer } from '../Global/global_variables';
import html2canvas from 'html2canvas';

export enum ScreenshotResolution {
    LowRes = 0,
    HD = 1,
    FullHD = 2,
    FourK = 3,
    ScreenRes = 4,
    VeryHighRes = 5,
}

export class ScreenshotExporter {
    async getScreenshot(resolutionMode: ScreenshotResolution, drawGUI: boolean, format: string): Promise<Uint8Array> {
        const cssW = window.innerWidth;
        const cssH = window.innerHeight;

        // Read dper as late as possible
        const dpr = window.devicePixelRatio;

        let width = window.innerWidth * dpr;
        let height = window.innerHeight * dpr;

        console.log('Exporting Screenshot');
        const resolutions = {
            [ScreenshotResolution.LowRes]: [320, 240],
            [ScreenshotResolution.HD]: [1280, 720],
            [ScreenshotResolution.FullHD]: [1920, 1080],
            [ScreenshotResolution.FourK]: [3840, 2160],
            [ScreenshotResolution.ScreenRes]: [width, height],
            [ScreenshotResolution.VeryHighRes]: [width * 10, height * 10],
        };

        [width, height] = resolutions[resolutionMode];

        let r = renderer();
        if (!r) return new Uint8Array();

        // it's easy to get to the maximum render size especially on high-DPR displays
        // so we just cap to the maximum resolution we can use
        const gl = r.getContext();
        const maxSize = gl.getParameter(gl.MAX_RENDERBUFFER_SIZE);
        const targetSize = width * height;

        if (targetSize > (maxSize * maxSize) / 8) {
            console.warn(`Target resolution (${width}x${height}) exceeds max renderbuffer size (${maxSize}). Capping size.`);
            let sizeMultiplier = Math.sqrt((maxSize * maxSize) / 8 / (width * height));
            width *= sizeMultiplier;
            height *= sizeMultiplier;
            console.log('Capped resolution to: ' + width + 'x' + height);
        }

        // resize the buffer for the screenshot
        if (!drawGUI) {
            r.setSize(width, height, false);
        }

        // normalize the format
        const normalizedFormat = format.toLowerCase() === 'jpeg' ? 'image/jpeg' : 'image/png';

        let dataUrl = '';

        if (!drawGUI) postProcess.applyPostProcess(0);
        postProcess.composer.render();

        if (drawGUI) {
            const container = document.getElementById('canvas-container');
            if (!container) return new Uint8Array();

            const canvas = await html2canvas(container as HTMLElement);
            dataUrl = canvas.toDataURL(normalizedFormat);
        } else {
            dataUrl = r.domElement.toDataURL(normalizedFormat);
        }

        // reset to original size
        const restoreDpr = window.devicePixelRatio;
        r.setSize(cssW, cssH, true);
        r.setSize(cssW * restoreDpr, cssH * restoreDpr, false);
        postProcess.applyPostProcess();
        postProcess.composer.render();
        getViewer().requestRender?.('ui');

        return this.dataURLToUint8Array(dataUrl);
    }

    dataURLToUint8Array(dataURL: string): Uint8Array {
        const base64 = dataURL.split(',')[1];
        const binary = atob(base64);
        const len = binary.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
    }
}
